"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContextMenu = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Plugin_1 = require("@skbkontur/plugin-js/lib/Plugin");

var ContextMenu_module_css_1 = tslib_1.__importDefault(require("./ContextMenu.module.css"));

var Link_1 = require("@skbkontur/react-ui/components/Link");

var common_1 = require("../../../utils/common");

var configuration_1 = require("../../../contexts/configuration");

var ContextMenu =
/** @class */
function (_super) {
  tslib_1.__extends(ContextMenu, _super);

  function ContextMenu() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.onCertInfoClick = function () {
      var pluginFullInfo = _this.context.pluginFullInfo;
      var plugin = pluginFullInfo ? pluginFullInfo.plugin : undefined;
      var certificate = _this.props.item.certificate;
      plugin.displayCertificate(certificate);

      _this.context.trackEvent('showCertInfo');
    };

    return _this;
  }

  ContextMenu.prototype.render = function () {
    var warnBeforeExpiringPeriod = this.context.warnBeforeExpiringPeriod;
    var item = this.props.item;
    /**
     * Ссылка информация о сертификате вызывает функцию Плагина/Тулбокс для отображения
     * системного окошка сертификата. Если сертификат получен из реквизитов пользователя,
     * то отобразить его неполучится.
     * Для Плагина еще можно придумать решение, но тут нужен контент сертификата в base64,
     * которой пока не запрашивается.
     */

    var storeInfo = item.storeInfo;
    var link = storeInfo.type !== Plugin_1.StoreType.Requisite ? react_1.default.createElement("div", {
      className: ContextMenu_module_css_1.default.item,
      "data-tid": "displayLink"
    }, react_1.default.createElement(Link_1.Link, {
      onClick: this.onCertInfoClick
    }, "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0435")) : null;
    return react_1.default.createElement("div", {
      className: ContextMenu_module_css_1.default.menu
    }, react_1.default.createElement("div", {
      className: ContextMenu_module_css_1.default.item,
      "data-tid": "menuValidTo_" + item.certificate.thumbprint()
    }, this.context.certificateProcessor.getValidToMessage(item, {
      capital: true,
      declarative: true
    })), react_1.default.createElement("div", {
      className: ContextMenu_module_css_1.default.gray
    }, "\u0421\u0440\u043E\u043A \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u043D\u0430\xA0\u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0435 \u0437\u0430\xA0", warnBeforeExpiringPeriod, "\xA0", common_1.getPluralForm(warnBeforeExpiringPeriod, ['день', 'дня', 'дней']), " \u0434\u043E\xA0\u0435\u0433\u043E \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F, \u0447\u0442\u043E\u0431\u044B \u0432\u044B \u0432\u043E\u0432\u0440\u0435\u043C\u044F \u043C\u043E\u0433\u043B\u0438 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0435\u0433\u043E", link));
  };

  ContextMenu.contextType = configuration_1.configurationContext;
  return ContextMenu;
}(react_1.default.Component);

exports.ContextMenu = ContextMenu;